'use client';

export default function VideoBlock({title, src}: {title: string; src: string}) {
  return (
    <video
      onContextMenu={(e) => e.preventDefault()}
      className="aspect-video rounded-md"
      src={src}
      title={title}
      controls
      controlsList="nodownload"
      autoPlay
      muted
    />
  );
}
